<div class="container">
  <ion-icon src="assets/icon/jacto-logo.svg" class="icon"></ion-icon>
  <p class="text" translate>emptyResult.component.title</p>
</div>
